<div class="relative" *ngIf="method">
    <div class="align-center mb-5 block w-full pr-0 dark:filter-yellow">
        <img class="dark:hidden" src="{{ env.PAYMENT_PORTAL_URL + method.imageUrl }}" alt="" />
    </div>

    <div class="box-border px-4 py-0">
        <div>
            <span>{{ 'PAYMENT_METHOD_DESCRIPTION' | translate }}</span>
        </div>
    </div>
</div>
